import type { ProductEntity } from '@/entities/assortment/model/types'
import type { ProductsQueryItemModel } from '@/shared/generated'

type AnyObject = Record<string, any>

/**
 * Allow to select filed value from nested product scheme
 * @param item Searchable entity
 * @param field field name to search
 * @returns
 */
export const getEntityFieldValue = <T extends AnyObject>(
	item: T,
	field: string
) =>
	item?.fields?.aggregated_fields?.[field] ??
	item?.[field] ??
	item?.fields?.[field] ??
	item?.custom_fields?.[field] ??
	null

export const isAggregated = (item: ProductsQueryItemModel) => item?.products

/**
 * Get composed row id for product in pricing line
 * @param row Pricing line model
 * @returns Composed row id og+line_id+sku
 */
export const getRowId = (row: ProductEntity | ProductsQueryItemModel) =>
	`${row.fields.optimization_group_id}__${row.line_id}__${(row as ProductEntity)?.sku || ''}`

/**
 * Get composed pricing line id
 * @param row Pricing line model
 * @returns Composed node id og+line_id
 */
export const getNodeId = (row: ProductsQueryItemModel | ProductEntity) =>
	`${row.fields.optimization_group_id}__${row.line_id}`
